import { Customer } from '@/types'
import { CreateCustomerRequest } from '@/types/apis/customers/CreateCustomerRequest'
import { CreateCustomerResponse } from '@/types/apis/customers/CreateCustomerResponse'
import { DeleteCustomerRequest } from '@/types/apis/customers/DeleteCustomerRequest'
import { DeleteCustomerResponse } from '@/types/apis/customers/DeleteCustomerResponse'
import { GetAllCustomersRequest } from '@/types/apis/customers/GetAllCustomersRequest'
import { GetAllCustomersResponse } from '@/types/apis/customers/GetAllCustomersResponse'
import { GetCustomerRequest } from '@/types/apis/customers/GetCustomerRequest'
import { GetCustomerResponse } from '@/types/apis/customers/GetCustomerResponse'
import { ImportCustomerFromCsvRequest } from '@/types/apis/customers/ImportCustomerFromCsvRequest'
import { ImportCustomerFromCsvResponse } from '@/types/apis/customers/ImportCustomerFromCsvResponse'
import { UpdateCustomerRequest } from '@/types/apis/customers/UpdateCustomerRequest'
import { UpdateCustomerResponse } from '@/types/apis/customers/UpdateCustomerResponse'

import axios from './axios'

const API_ENDPOINT = '/customer'

export const getAllCustomers = (request?: GetAllCustomersRequest): Promise<GetAllCustomersResponse> => {
  return axios.get(`${API_ENDPOINT}`, { params: request })
}

export const getCustomersApi = (): Promise<Customer[]> => {
  return axios.get(`${API_ENDPOINT}/all`)
}

export const getCustomer = (request?: GetCustomerRequest): Promise<GetCustomerResponse> => {
  return axios.get(`${API_ENDPOINT}${request?.id ? `/${request.id}` : ''}`)
}

export const createCustomer = (request: CreateCustomerRequest): Promise<CreateCustomerResponse> => {
  return axios.post(API_ENDPOINT, request)
}

export const updateCustomer = (request: UpdateCustomerRequest): Promise<UpdateCustomerResponse> => {
  return axios.put(`${API_ENDPOINT}/${request.id}`, request)
}

export const deleteCustomer = (request: DeleteCustomerRequest): Promise<DeleteCustomerResponse> => {
  return axios.delete(`${API_ENDPOINT}/${request.id}`)
}

export const importCustomerFromCsv = (
  request: ImportCustomerFromCsvRequest
): Promise<ImportCustomerFromCsvResponse> => {
  return axios.post(`${API_ENDPOINT}/import-csv`, request)
}

export const importCsvTypeInsert = (request: ImportCustomerFromCsvRequest): Promise<ImportCustomerFromCsvResponse> => {
  return axios.post(`${API_ENDPOINT}/import-csv`, request)
}
